import { render, staticRenderFns } from "./VContracts.vue?vue&type=template&id=5eab57b5&"
import script from "./VContracts.vue?vue&type=script&lang=js&"
export * from "./VContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports